import { Controller } from "@hotwired/stimulus";

// The one-time "Your pass is in Apple Wallet" line under the Apple badge
// (ID-176). After a tap on Add to Apple Wallet the page cannot tell whether
// the member tapped Add or Cancel on Apple's sheet. An iPhone registers the
// pass with us within seconds of an Add, so from the tap on this asks the
// server every two seconds, for up to a minute, and shows the line as soon
// as the answer is yes. Nothing is asked until the tap, so a later visit to
// the page never shows the line.
export default class extends Controller {
  static targets = ["note"];
  static values = { url: String, attempts: { type: Number, default: 30 } };

  disconnect() {
    this.stop();
  }

  watch() {
    this.stop();
    this.remaining = this.attemptsValue;
    this.timer = setInterval(() => this.poll(), 2000);
  }

  async poll() {
    if (this.remaining <= 0) {
      this.stop();
      return;
    }
    this.remaining -= 1;
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } });
      if (!response.ok) return;
      const { added } = await response.json();
      if (added) {
        this.noteTarget.classList.remove("d-none");
        this.stop();
      }
    } catch {
      // A failed request is just one missed attempt; the next tick tries again.
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
